// 第三方库（Vue、路由、状态管理、工具库等）
import { createApp } from 'vue'
import md5 from 'js-md5'
import { ElMessageBox } from 'element-plus'

// Element Plus 全局安装
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'

// Vue 相关核心功能（Router、Store、插件）
import router from './router/index'
import resetRouter from './router/resetRouter'
import './router/routerGuard'
import './router/storageAuthListener'
import store from '@/store/index'

// 本地插件和全局配置
import bus from '@/api/network/bus.js'
import request from '@/api/network/request'
import myMessage from '@/api/network/message'
import apiUrl from '@/api/config/apiUrl'

// 工具类（按功能分组）
import arrayUtil from '@/api/utils/arrayUtil'
import timeUtil from '@/api/utils/timeUtil'

// 全局样式
import '@/assets/css/global.css'
import '@/assets/css/common.css'

// 应用主入口
import App from './App.vue'

const app = createApp(App)
// 配置全局属性
app.config.globalProperties.$md5 = md5
app.config.globalProperties.$request = request
app.config.globalProperties.$myMessage = myMessage
app.config.globalProperties.$messageBox = ElMessageBox
app.config.globalProperties.$bus = bus
app.config.globalProperties.$apiDomain = process.env.VUE_APP_API_URL

// 工具类
app.config.globalProperties.$apiUrl = apiUrl
app.config.globalProperties.$arrayUtil = arrayUtil
app.config.globalProperties.$timeUtil = timeUtil

// 重置路由
app.config.globalProperties.$resetRouter = resetRouter

// 全局安装Element Plus 并设置中文语言
app.use(ElementPlus, { locale: zhCn, size: 'default' })
// 全局注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

// 使用路由和状态管理
app.use(router)
app.use(store)

app.mount('#app')

window.addEventListener('popstate', function () {
    history.pushState(null, null, document.URL)
})

// 只在生产环境启用版本检查
if (process.env.NODE_ENV === 'production') {
    // 页面加载时检查一次
    checkVersion()

    // 当用户切换回页面时再检查一次
    window.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            checkVersion()
        }
    })
}
async function checkVersion () {
    try {
        // 获取当前运行的旧版本（可能来自缓存）
        const oldMeta = document.querySelector('meta[name="app-version"]')
        const oldVersion = oldMeta ? oldMeta.content : 'legacy_version'

        // 获取服务器上的最新版本（强制绕过缓存）
        const html = await fetch('/?t=' + Date.now()).then(r => r.text())
        const latestMeta = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('meta[name="app-version"]')
        const latestVersion = latestMeta ? latestMeta.content : 'legacy_version'
        console.log(`oldVersion: ${oldVersion}, latestVersion: ${latestVersion}`)

        // 静默更新
        if (!latestMeta || latestVersion !== oldVersion) {
            console.log(`[静默更新] 旧版本: ${oldVersion}, 新版本: ${latestVersion}`)
            window.location.reload()
        }
    } catch (e) {
        console.log('版本检查失败:', e)
    }
}
